import React from 'react';
import { inject, observer } from 'mobx-react';
import H5DownloadApp from './h5';
import PCDownloadApp from './pc';
import type { AppStore } from '@stores/app/store';
import type { SiteStore } from '@stores/site/store';
import type { UserAction } from '@stores/user/action';

interface DownloadAppProps {
    app?: AppStore;
    site?: SiteStore;
    user?: UserAction;
    nav?: any
    navClick?: any
    closeAppDownloadEnter?: any
}

@inject('app', 'site', 'user')
@observer
// 下载APP入口，h5是悬浮在页面顶部，pc是放在页面内容右侧
class DownloadApp extends React.Component<DownloadAppProps> {
    componentDidMount() {
        // 可以在这里添加初始化逻辑
        // console.log('这是header');
    }

    render() {
        const { site, app, closeAppDownloadEnter, ...props } = this.props;
        const platform = app?.platform || 'h5';
        
        if (platform === 'pc') {
            return <PCDownloadApp {...props} />;
        }
        
        return <H5DownloadApp closeAppDownloadEnter={closeAppDownloadEnter} {...props} />;

    }
}

export default DownloadApp;